import { inject } from "@angular/core";
import { CanDeactivateFn } from "@angular/router";

import { DocumentsStore } from "@documentation/state/documents.store";

export interface CanComponentDeactivate {
  canDeactivate: () => boolean | Promise<boolean>;
}

export const unsavedChangesGuard: CanDeactivateFn<CanComponentDeactivate> = async (component) => {
  const docsStore = inject(DocumentsStore);

  if (docsStore.isNavigatingSafely()) {
    docsStore.setNavigatingSafely(false); // Reset the flag
    return true;
  }

  if (component && typeof component.canDeactivate === "function") {
    const componentResult = await component.canDeactivate();
    if (!componentResult) {
      return false;
    }
  }

  // Consider both draft new page and existing page with dirty edits
  const hasUnsavedChanges = docsStore.isDirty();

  if (!hasUnsavedChanges) {
    return true;
  }

  return await docsStore.handleUnsavedChangesBeforeNavigation();
};
